import { Columns3 } from 'lucide-react';

import { Card } from '@/components/ui/Card';
import { Select } from '@/components/ui/Select';
import { Badge } from '@/components/ui/Badge';
import { MAPPING_FIELDS } from '@/features/import/headerMap';
import type { ColumnMapping } from '@/features/network/models';

export function ColumnMappingPanel({
  headers,
  mapping,
  previewRows,
  onChange,
}: {
  headers: string[];
  mapping: ColumnMapping;
  previewRows: Array<Record<string, unknown>>;
  onChange: (next: ColumnMapping) => void;
}) {
  if (headers.length === 0) return null;

  return (
    <Card className="p-6">
      <div className="flex items-center gap-2 text-lg font-semibold">
        <Columns3 className="h-5 w-5" />
        Mapping колонок
      </div>
      <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
        Если входной Excel отличается по заголовкам, вручную сопоставь колонки перед расчётом графа.
      </p>

      <div className="mt-5 grid gap-4 2xl:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)]">
        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
          {MAPPING_FIELDS.map((field) => (
            <div key={field.key} className="rounded-2xl border border-slate-200 p-3 dark:border-slate-800">
              <div className="mb-2 flex items-center gap-2 text-sm font-medium">
                <span>{field.label}</span>
                {field.required ? <Badge className="border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-900 dark:bg-rose-950/40 dark:text-rose-200">required</Badge> : null}
              </div>
              <Select
                value={mapping[field.key] ?? ''}
                onChange={(event) => onChange({ ...mapping, [field.key]: event.target.value || undefined })}
              >
                <option value="">Не использовать</option>
                {headers.map((header) => (
                  <option key={header} value={header}>{header}</option>
                ))}
              </Select>
            </div>
          ))}
        </div>

        <div className="rounded-3xl border border-slate-200 p-4 dark:border-slate-800">
          <div className="text-sm font-medium">Превью данных</div>
          <div className="mt-3 overflow-auto">
            <table className="min-w-full border-separate border-spacing-0 text-xs">
              <thead>
                <tr>
                  {headers.slice(0, 8).map((header) => (
                    <th key={header} className="sticky top-0 border-b border-slate-200 bg-white px-2 py-2 text-left dark:border-slate-800 dark:bg-slate-950">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {previewRows.slice(0, 5).map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {headers.slice(0, 8).map((header) => (
                      <td key={header} className="border-b border-slate-100 px-2 py-2 text-slate-600 dark:border-slate-900 dark:text-slate-300">
                        {String(row[header] ?? '')}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Card>
  );
}
